<app-auth-header></app-auth-header>
<div class="w-full fixed bottom-0 z-50">
  <app-footer></app-footer>
</div>

<div
  class="relative h-[94%] bg-cover bg-center text-white flex items-center justify-center"
  style="background-image: url('assets/images/home_bg_img.png')"
>
  <div class="absolute inset-0 bg-[#272c36] bg-opacity-60"></div>

  <div
    class="fixed z-10 flex justify-center w-[53.281vw] max-h-[72vh] bg-[#F1F3F5] mb-24 rounded-[4px]"
  >
    <div class="flex flex-col items-center">
      <h3
        class="!text-[#21252A] !text-center !mt-[45px] !text-[2rem] !font-bold font-roboto w-[377px] justify-center leading-[57.6px]"
      >
        Recover Your Account
      </h3>
      <h6
        class="text-[#343A40] !text-[1.25rem] !mt-[10px] !text-center !font-semibold text-custom leading-6 tracking-tight-negative"
      >
        Enter your email address associated with your account.
      </h6>
      <div class="w-[384px] h-[280px] bg-[#fef8f5] mb-10 p-[39px] pt-[26px] rounded-[8px]" style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);">
        <!-- Message -->
        <p class="text-[#21252A] font-Inter text-[1rem] font-medium  leading-6 mb-8">
          We have sent a request to our support team to help you reset your
          password. You will receive a confirmation call shortly with your new
          temporary password. <br> you receive the temporary password, log in
          and change it to one of your choice.
        </p>

        <!-- Button -->
        <div class="flex items-center justify-center mb-[10px]">
            <button
            (click)="navigateTo()"
              class="bg-[#E76B3F] w-[92px] h-[42px] text-[1rem] font-roboto text-[#F1F3F5] !font-semibold px-6 py-2 rounded-[5px] leading-{-0.03rem}"
             >
              OK
            </button>
          </div>
          
    </div>
    </div>
  </div>
</div>
